import { IoClose } from 'react-icons/io5';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@ds';

export type ReplaceExistingRouteModalProps = {
  isPartialRoute: boolean;
  startTime: string;
  isOpen: boolean;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full';
  onConfirm: () => void;
  onClose: () => void;
};

export const ReplaceExistingRouteModal = ({
  isPartialRoute,
  startTime,
  isOpen,
  size = 'md',
  onConfirm,
  onClose,
}: ReplaceExistingRouteModalProps) => {
  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      closeButton={<IoClose size={45} style={{ top: 15 }} />}
      classNames={{
        base: 'px-6',
        body: 'border-y-1 border-base-30 px-0 py-6 text-s-r text-base-20',
        header: 'px-0 font-secondary text-hl! text-base-20',
        footer: 'px-0 flex gap-6',
        wrapper: 'z-420',
        backdrop: 'z-419',
      }}
    >
      <ModalContent>
        {(handleClose) => (
          <>
            <ModalHeader>Replace Existing Route?</ModalHeader>
            <ModalBody>
              <div className="flex flex-col gap-8">
                <span className="text-m-r text-base-5">
                  {isPartialRoute
                    ? `Applying the suggested route will replace all existing main and custom legs, except for surgeon custom legs, starting from ${startTime}`
                    : 'Applying the suggested route will replace all existing main and custom legs in all segment(s).'}
                </span>
                <span className="text-m-r text-base-5">Do you want to continue?</span>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button size="md" variant="outline" onPress={handleClose}>
                Cancel
              </Button>
              <Button size="md" color="default" variant="solid" onPress={onConfirm}>
                Replace Route
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
